module.exports = __webpack_public_path__ + "static/media/eventos.50fe1284.svg";